/*
*	MG2 Media JS Framework
*	@author  François Vandal
*	@version: 0.9.4
*	Last update: 6 september 2016
*/

(function ($, global, undefined) {
	var html = $('html');
	var lang = html.attr('lang');
	var defaultLang = html.attr('data-default-lang');

	var modules = {};
	var components = {};
	var pages = {};

	/* Modules */
	var createModule = function createModule(module) {
		return $.extend({
			init: $.noop,
			pageLoad: $.noop,
			pageChange: $.noop,
			pageEnter: $.noop,
			pageLeave: $.noop,
			pageStartChange: $.noop
		}, module);
	};

	var exportModule = function exportModule(key, module) {
		modules[key] = createModule(module);

		return modules[key];
	};

	/* Pages */
	var createPage = function createPage(page) {
		return $.extend({
			init: $.noop,
			pageLoad: $.noop,
			pageEnter: $.noop,
			pageLeave: $.noop
		}, page);
	};

	var exportPage = function exportPage(key, page) {
		pages[key] = createPage(page);

		return pages[key];
	};

	var checkForPage = function checkForPage(pageIdNum) {
		var currPage = $('.main-content .page[data-page-id-num=' + pageIdNum + ']').attr('data-page-id');

		if (pages[pageIdNum] !== undefined) {
			pages[pageIdNum].init('#page-' + currPage);
			pages[pageIdNum].pageLoad('#page-' + currPage);
		}
	};

	/* Components */
	var createComponent = function createComponent(component) {
		return $.extend({ init: $.noop }, component);
	};

	var exportComponent = function exportComponent(key, component) {
		components[key] = createPage(component);

		return pages[key];
	};

	var start = function start() {
		var lang = $('html').attr('lang');
		var defaultLang = $('html').attr('data-default-lang');

		var currPathname = location.pathname;
		var currentIdNum = $('.main-content .page').data('pageIdNum');

		if (currPathname !== '/' && currPathname.substring(0, 1) === '/') {
			currPathname = currPathname.substring(1);
		}

		if (lang !== defaultLang) {
			currPathname = currPathname.substring(lang.length);
		}

		currPathname = currPathname !== '/' ? currPathname : 'home';

		if (currPathname.substring(currPathname.length - 1) === '/') {
			currPathname = currPathname + 'home';
		}

		if (currPathname.substring(0, 1) === '/') {
			currPathname = currPathname.substring(1);
		}

		currPathname = currPathname.split('?')[0];
		if (currPathname.substring(currPathname.length - 1) === '/') {
			currPathname = currPathname.substring(0, currPathname.length - 1);
		}

		if (lang !== defaultLang) {
			if (currPathname.substring(0, lang.length) === lang) {
				currPathname = currPathname.substring(lang.length);
			}
		}

		if (currPathname.substring(0, 1) === '/') {
			currPathname = currPathname.substring(1);
		}

		currPathname = currPathname.split('/')[0];

		$.each(Fw.modules.models(), function () {
			this.init('body');
			this.pageLoad('body');
		});

		$('html').attr('data-curr-page', 'page-' + currPathname);
		checkForPage(currentIdNum);

		return Fw;
	};

	global.Fw = $.extend(global.Fw, {
		data: '',

		modules: {
			models: function models() {
				return modules;
			},

			export: exportModule
		},

		component: {
			models: function models() {
				return components;
			},

			export: exportComponent
		},

		page: {
			models: function models() {
				return pages;
			},

			export: exportPage,

			checkForPage: checkForPage
		},

		start: start
	});
})(jQuery, window);
(function ($, undefined) {

	'use strict';

	var doc = $(document);
	var currPage;
	var transitionEnd = 'transitionend webkitTransitionEnd oTransitionEnd otransitionend';
	var body;
	var items;
	var checkLabel;
	var checkboxItems;
	var checkboxItemsInner;
	var file;
	var fileInput;
	var formSwitch;
	var formCheck;
	var selectCountry;

	var validateForm = function validateForm(ctn) {
		ctn.each(function () {
			var t = $(this);
			var toValidateItems = $('.form-input:not(.select-state-input:not(.selected))', t);
			var toValidateUpload = $('.form-input-upload.required', t);
			var toValidateCheck = $('.form-check-input.required', t);
			var password = $('.js-password', t);
			var passwordConfirm = $('.js-password-confirm', t);
			var email = $('.js-email', t);
			var emailConfirm = $('.js-email-confirm', t);
			var btn = $('.js-form-btn', t);
			var isOk = true;
			var passwordOk = true;
			var termsOk = true;
			var checkOk = true;
			var emailOk = true;
			var fieldsErrorMessage = $('.js-form-error-message.fields', t);
			var fieldsErrorCheckbox = $('.js-form-error-message.checkbox', t);
			var fieldsErrorTerms = $('.js-form-error-message.terms', t);
			var fieldsErrorPassword = $('.js-form-error-message.password', t);
			var fieldsErrorEmail = $('.js-form-error-message.email-check', t);

			toValidateItems.each(function () {
				var tChild = $(this);
				validateField(tChild);
				if (tChild.hasClass('error')) {
					isOk = false;
				}
			});

			toValidateUpload.each(function () {
				var tUpload = $(this);
				var input = $('.form-input-upload-input', tUpload);

				if (input.val() === '') {
					tUpload.addClass('error');
				}

				if (tUpload.hasClass('error')) {
					isOk = false;
				}
			});

			toValidateCheck.each(function () {
				var tCheck = $(this);
				var tCtn = tCheck.closest('.form-checkbox-ctn');

				if (!tCheck.is(':checked')) {
					tCtn.addClass('error');

					if (tCtn.attr('name') !== 'terms') {
						checkOk = false;
					}
				} else {
					tCtn.removeClass('error');
				}

				if (tCheck.attr('name') === 'terms' && tCtn.hasClass('error')) {
					termsOk = false;
				}

				if (tCtn.hasClass('error')) {
					termsOk = false;
				}
			});

			if (password.length !== 0 && passwordConfirm.length !== 0 && (password.val() !== passwordConfirm.val() || password.val().length === 0)) {
				if (password.val().length === 0) {
					password.removeClass('success').addClass('error');
					passwordOk = false;
				} else {
					password.addClass('success').removeClass('error');
					passwordOk = true;
				}

				if (password.val() !== passwordConfirm.val() || passwordConfirm.val().length === 0) {
					passwordConfirm.removeClass('success').addClass('error');
					passwordOk = false;
				} else {
					passwordConfirm.removeClass('error');
					passwordOk = true;

					if (password.val().length !== 0) {
						passwordConfirm.addClass('success');
					}
				}
			}

			if (email.length !== 0 && emailConfirm.length !== 0 && (email.val() !== emailConfirm.val() || email.val().length === 0)) {
				if (email.val().length === 0) {
					email.removeClass('success').addClass('error');
					emailOk = false;
				} else {
					email.addClass('success').removeClass('error');
					emailOk = true;
				}

				if (email.val() !== emailConfirm.val() || email.val().length === 0) {
					emailConfirm.removeClass('success').addClass('error');
					emailOk = false;
				} else {
					emailConfirm.removeClass('error');
					emailOk = true;

					if (email.val().length !== 0) {
						emailConfirm.addClass('success');
					}
				}
			}

			t.addClass('is-checked');

			if (!termsOk) {
				fieldsErrorTerms.slideDown(300);
			} else {
				fieldsErrorTerms.slideUp(300);
			}

			if (!checkOk) {
				fieldsErrorCheckbox.slideDown(300);
			} else {
				fieldsErrorCheckbox.slideUp(300);
			}

			if (password.length !== 0 && passwordConfirm.length !== 0) {
				if (password.length !== 0 && passwordOk) {
					ctn.addClass('has-password');
					password.add(passwordConfirm).removeClass('error');
					fieldsErrorPassword.slideUp(300);
				} else {
					ctn.removeClass('has-password');
					password.add(passwordConfirm).addClass('error');
					fieldsErrorPassword.slideDown(300);
				}
			}

			if (email.length !== 0 && emailConfirm.length !== 0) {
				if (email.length !== 0 && emailOk) {
					ctn.addClass('has-email');
					email.add(emailConfirm).removeClass('error');
					fieldsErrorEmail.slideUp(300);
				} else {
					ctn.removeClass('has-email');
					email.add(emailConfirm).addClass('error');
					fieldsErrorEmail.slideDown(300);
				}
			}

			if (!isOk) {
				fieldsErrorMessage.slideDown(300);
			} else {
				fieldsErrorMessage.slideUp(300);
			}

			if (!isOk || !passwordOk || !termsOk || !checkOk || !emailOk) {
				btn.addClass('disabled');
				ctn.addClass('has-error');

				if (!passwordOk && password.hasClass('required')) {
					ctn.addClass('error-password');
				} else {
					ctn.removeClass('error-password');
				}
				return false;
			} else {
				btn.removeClass('disabled');
				ctn.removeClass('has-error').removeClass('error-password');

				fieldsErrorTerms.slideUp(300);
				return true;
			}
		});
	};

	var validateField = function validateField(elt) {
		var tag = elt[0].tagName;
		var type = elt.attr('type');
		var val = elt.val();
		var attrClass = elt.attr('data-validator-apply-class-on');
		var classTarget = attrClass !== undefined ? elt.closest(attrClass) : elt;
		//Choises for validate are : "email", "url", "tel" or "default". By default, an input type email takes the email validation,
		//the input type tel takes the tel validation and if the validate value is "default", then it do a normal check if the input has char
		var validate = elt.attr('data-validate');
		var reEmail = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
		var reUrl = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(:[0-9]+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;
		var reTel = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
		var emailValid = true;
		var whiteSpaceValid = true;
		var urlValid = true;
		var telValid = true;
		var inputValid = true;

		if (!val.replace(/\s/g, '').length) {
			whiteSpaceValid = false;
		}

		if (val !== '') {
			elt.addClass('has-value');
		} else {
			elt.removeClass('has-value');
		}

		if (tag === 'INPUT' && (type === 'email' || validate === 'email') && validate !== 'default') {
			emailValid = reEmail.test(val);
		} else if (tag === 'INPUT' && validate === 'url' && validate !== 'default') {
			urlValid = reUrl.test(val);
		} else if (tag === 'INPUT' && (type === 'tel' || validate === 'tel') && validate !== 'default') {
			telValid = reTel.test(val);
		} else if (elt.hasClass('form-input-upload-input')) {
			if (classTarget.add(elt).hasClass('required') && elt.val() !== '') {
				classTarget.add(elt).removeClass('error').addClass('success');
			} else {
				classTarget.add(elt).addClass('error').removeClass('success');
			}
		} else {
			classTarget.add(elt).addClass('success').removeClass('error');
			if (classTarget.hasClass('required') && $.trim(val).length === 0) {
				classTarget.add(elt).removeClass('success').addClass('error');
				inputValid = false;
			} else if (!classTarget.hasClass('required') && val.length === 0) {
				classTarget.add(elt).removeClass('success').removeClass('error');
			}
		}

		if (emailValid && urlValid && telValid && inputValid && whiteSpaceValid) {
			classTarget.add(elt).removeClass('error').addClass('success');
		} else if (val.length === 0 && !classTarget.hasClass('required')) {
			classTarget.add(elt).removeClass('error').removeClass('success');
		} else {
			classTarget.add(elt).addClass('error').removeClass('success');
		}
	};

	var formItemsBlur = function formItemsBlur(t) {
		var elt = t.target === undefined ? t : $(this);
		var ctn = elt.closest('.form-input');
		var form = ctn.closest('.js-form');

		validateField(elt);

		if (form.hasClass('is-checked')) {
			validateForm(form);
		}
	};

	var formCheckChange = function formCheckChange() {
		var t = $(this);
		var ctn = t.closest('.form-checkbox-ctn');
		var form = ctn.closest('.js-form');

		if (form.hasClass('is-checked')) {
			validateForm(form);

			if (t.is(':checked')) {
				ctn.removeClass('error');
			}
		}
	};

	var checkLabelClick = function checkLabelClick() {
		var t = $(this);
		var ctn = t.closest('.register-checkbox');

		if (input.hasClass('is-checked')) {
			input.removeClass('is-checked');
		} else {
			input.addClass('is-checked');
		}
	};

	var toggleCheckbox = function toggleCheckbox() {
		var t = $(this);
		var ctn = t.closest('.form-input-checkbox');
		var input = $('.form-input-checkbox-input', t);

		if (ctn.hasClass('checked')) {
			ctn.removeClass('checked');
			input.removeAttr('checked');
		} else {
			ctn.addClass('checked');
			input.attr('checked', 'checked');
		}
	};

	var fileInputChange = function fileInputChange() {
		var t = $(this);
		var label = t.closest('.form-input-upload-input-label');
		var labelDefault = label.attr('data-default-value');
		var labelValue = $('.form-input-upload-input-label-value', label);
		var ctn = t.closest(t.attr('data-validator-apply-class-on'));
		var form = ctn.closest('.js-form');

		if (t.val() !== '') {
			ctn.removeClass('error').addClass('success');
			labelValue.html(t.val().split('\\')[t.val().split('\\').length - 1]);
		} else {
			ctn.addClass('error').removeClass('success');
			labelValue.html(labelDefault);
		}

		if (form.hasClass('is-checked')) {
			validateForm(form);
		}
	};

	var formSwitchClick = function formSwitchClick() {
		var t = $(this);
		var elem = $(t).find('.checkbox');

		t.find('.form-checkbox-slider').toggleClass('active');
		if (elem.prop("checked")) {
			elem.removeAttr("checked");
		} else {
			elem.attr("checked", "checked");
		}
	};

	var updateStateSelect = function updateStateSelect() {
		var t = $(this);
		var val = t.val();
		var id = t.attr('data-id');
		var statesCtn = $('.select-state-ctn[data-id="' + id + '"]');
		$('.form-select-ctn, .form-select-ctn .form-select', statesCtn).removeClass('selected');

		if (val === 'CA' || val === 'CAN' || val === 'canada' || val === 'Canada') {
			$('.form-select-ctn.canada, .form-select-ctn.canada .form-select', statesCtn).addClass('selected');
		} else if (val === 'US' || val === 'USA' || val === 'United-States' || val === 'united-states') {
			$('.form-select-ctn.us, .form-select-ctn.us .form-select', statesCtn).addClass('selected');
		} else {
			$('.form-select-ctn.other, .form-select-ctn.other .form-select', statesCtn).addClass('selected');
		}
	};

	var init = function init() {
		body = $('body');
		items = $('.form-input:not([type=file])');

		checkLabel = $('.register-checkbox-label');
		checkboxItems = $('.form-input-checkbox');
		checkboxItemsInner = $('.form-input-checkbox-inner', checkboxItems);
		file = $('.form-input-upload');
		fileInput = $('.form-input-upload-input', file);
		formSwitch = $('.form-switch');
		formCheck = $('.form-check-input');
		selectCountry = $('.select-country-input');

		checkLabel.click(checkLabelClick);
		checkboxItemsInner.click(toggleCheckbox);
		fileInput.change(fileInputChange);
		formSwitch.click(formSwitchClick);
		formCheck.change(formCheckChange);
		selectCountry.change(updateStateSelect);

		items.each(function () {
			if (!$(this).hasClass('no-blur')) {
				$(this).blur(formItemsBlur);
			}
		});
	};

	$(init);

	var form = Fw.component.export('form', {
		init: init,
		validateForm: validateForm
	});
})(jQuery);
(function ($, undefined) {
	'use strict';

	var initSlider = function initSlider() {
		if ($('.slider-com-one-slide').length) {
			$('.slider-com-inner').each(function () {
				var t = $(this);

				t.slick({
					arrows: false,
					dots: true,
					slide: '.slider-com-one-slide',
					slidesToShow: 1,
					slidesToScroll: 1,
					autoplay: true,
					autoplaySpeed: 3000,
					speed: 600
				});
			});
		}
	};

	var init = function init() {
		initSlider();
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
(function ($, undefined) {
	'use strict';

	var updateBgPosLabel = function updateBgPosLabel() {
		var t = $(this);
		var value = t.val() + "%";
		var key = t.data('key');

		var langs = $('html').attr('data-all-langs');
		updateLabelLangs(key, value, langs, function () {}, true);
	};

	var changeBgPos = function changeBgPos() {
		var t = $(this);
		var ctn = $('.background-img-' + t.attr('data-id'));
		var currentPosition = ctn.css('backgroundPosition');
		var value = t.val();
		var otherVal;

		// change background
		if (t.hasClass('horizontal')) {
			otherVal = currentPosition.split('% ');
			ctn.css('backgroundPosition', value + '% ' + otherVal[1]);
		} else if (t.hasClass('vertical')) {
			otherVal = currentPosition.split(' ');
			ctn.css('backgroundPosition', otherVal[0] + ' ' + value + '%');
		}
	};

	var toggleElement = function toggleElement() {
		var t = $(this);
		var ctn = t.closest('.toggle-outer-ctn');
		var el = ctn.find('.element-to-toggle');

		if (el.css('display') === 'block' && el.find('input, select').hasClass('required')) {
			el.find('input.required, select.required').removeClass('required').addClass('derequired');
		} else if (el.css('display') !== 'block' && el.find('input, select').hasClass('derequired')) {
			el.find('input.derequired, select.derequired').removeClass('derequired').addClass('required');
		}

		ctn.toggleClass('open');
		el.slideToggle();
	};

	var init = function init() {
		var bgPosRange = $('.image-bg-pos');

		$('.toggle-trigger-element').click(toggleElement);
		bgPosRange.on('change', updateBgPosLabel);
		bgPosRange.on('input', changeBgPos);
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
(function ($, undefined) {

	'use strict';

	var sitekey = '6Lcb53IUAAAAANte3pFbpj-7fKffMlEHxsyRuvQS';

	/* RECAPTCHA UTIL FUNCTION */
	/**
  * Render recaptchas dynamically.
  * @param   btn         An element referencing the button or a string 
  *                      referencing the Id of the element.
  * @param   callback    A function to be called after recaptcha has 
  *                      completed its check. The function is passed back
  *                      the recaptcha response and the form element.
  * @param   validate    (optional) A boolean to know if a form needs to be 
  *                      validated using the formValidator in com/form.js.
  * @param   form        (optional) A jQuery object reference the form to be
  *                      validated using formValidator in com/form.js.
  */

	var recaptcha = function recaptcha(btn, _callback, validate, form) {
		if (btn && window.grecaptcha) {
			if (window.grecaptcha.render) {
				grecaptcha.render(btn, {
					'sitekey': sitekey,
					'callback': function callback(response) {
						var formValidator = Fw.component.models().form.validateForm;
						var validated = true;
						if (validate) {
							// console.log('validating');
							validated = false;
							formValidator(form);
							if (!form.hasClass('has-error')) {
								validated = true;
							}
						}

						if (validated) {
							// console.log('calling callback');
							_callback(response, form);
						} else {
							// console.log('resetting');
							grecaptcha.reset();
						}
					},
					'badge': 'inline'
				});
			} else {
				setTimeout(function () {
					recaptcha(btn, _callback, validate, form);
				}, 250);
			}
		} else if (btn && !window.grecaptcha) {
			setTimeout(function () {
				recaptcha(btn, _callback, validate, form);
			}, 250);
		}
	};

	var utils = Fw.component.export('utils', {
		recaptcha: recaptcha
	});
})(jQuery);
/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.6.0
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
!function(a){"use strict";"function"==typeof define&&define.amd?define(["jquery"],a):"undefined"!=typeof exports?module.exports=a(require("jquery")):a(jQuery)}(function(a){"use strict";var b=window.Slick||{};b=function(){function c(c,d){var f,e=this;e.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:a(c),appendDots:a(c),arrows:!0,asNavFor:null,prevArrow:'<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',nextArrow:'<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(b,c){return a('<button type="button" data-role="none" role="button" tabindex="0" />').text(c+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},e.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},a.extend(e,e.initials),e.activeBreakpoint=null,e.animType=null,e.animProp=null,e.breakpoints=[],e.breakpointSettings=[],e.cssTransitions=!1,e.focussed=!1,e.interrupted=!1,e.hidden="hidden",e.paused=!0,e.positionProp=null,e.respondTo=null,e.rowCount=1,e.shouldClick=!0,e.$slider=a(c),e.$slidesCache=null,e.transformType=null,e.transitionType=null,e.visibilityChange="visibilitychange",e.windowWidth=0,e.windowTimer=null,f=a(c).data("slick")||{},e.options=a.extend({},e.defaults,d,f),e.currentSlide=e.options.initialSlide,e.originalSettings=e.options,"undefined"!=typeof document.mozHidden?(e.hidden="mozHidden",e.visibilityChange="mozvisibilitychange"):"undefined"!=typeof document.webkitHidden&&(e.hidden="webkitHidden",e.visibilityChange="webkitvisibilitychange"),e.autoPlay=a.proxy(e.autoPlay,e),e.autoPlayClear=a.proxy(e.autoPlayClear,e),e.autoPlayIterator=a.proxy(e.autoPlayIterator,e),e.changeSlide=a.proxy(e.changeSlide,e),e.clickHandler=a.proxy(e.clickHandler,e),e.selectHandler=a.proxy(e.selectHandler,e),e.setPosition=a.proxy(e.setPosition,e),e.swipeHandler=a.proxy(e.swipeHandler,e),e.dragHandler=a.proxy(e.dragHandler,e),e.keyHandler=a.proxy(e.keyHandler,e),e.instanceUid=b++,e.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,e.registerBreakpoints(),e.init(!0)}var b=0;return c}(),b.prototype.activateADA=function(){var a=this;a.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},b.prototype.addSlide=b.prototype.slickAdd=function(b,c,d){var e=this;if("boolean"==typeof c)d=c,c=null;else if(0>c||c>=e.slideCount)return!1;e.unload(),"number"==typeof c?0===c&&0===e.$slides.length?a(b).appendTo(e.$slideTrack):d?a(b).insertBefore(e.$slides.eq(c)):a(b).insertAfter(e.$slides.eq(c)):d===!0?a(b).prependTo(e.$slideTrack):a(b).appendTo(e.$slideTrack),e.$slides=e.$slideTrack.children(this.options.slide),e.$slideTrack.children(this.options.slide).detach(),e.$slideTrack.append(e.$slides),e.$slides.each(function(b,c){a(c).attr("data-slick-index",b)}),e.$slidesCache=e.$slides,e.reinit()},b.prototype.animateHeight=function(){var a=this;if(1===a.options.slidesToShow&&a.options.adaptiveHeight===!0&&a.options.vertical===!1){var b=a.$slides.eq(a.currentSlide).outerHeight(!0);a.$list.animate({height:b},a.options.speed)}},b.prototype.animateSlide=function(b,c){var d={},e=this;e.animateHeight(),e.options.rtl===!0&&e.options.vertical===!1&&(b=-b),e.transformsEnabled===!1?e.options.vertical===!1?e.$slideTrack.animate({left:b},e.options.speed,e.options.easing,c):e.$slideTrack.animate({top:b},e.options.speed,e.options.easing,c):e.cssTransitions===!1?(e.options.rtl===!0&&(e.currentLeft=-e.currentLeft),a({animStart:e.currentLeft}).animate({animStart:b},{duration:e.options.speed,easing:e.options.easing,step:function(a){a=Math.ceil(a),e.options.vertical===!1?(d[e.animType]="translate("+a+"px, 0px)",e.$slideTrack.css(d)):(d[e.animType]="translate(0px,"+a+"px)",e.$slideTrack.css(d))},complete:function(){c&&c.call()}})):(e.applyTransition(),b=Math.ceil(b),e.options.vertical===!1?d[e.animType]="translate3d("+b+"px, 0px, 0px)":d[e.animType]="translate3d(0px,"+b+"px, 0px)",e.$slideTrack.css(d),c&&setTimeout(function(){e.disableTransition(),c.call()},e.options.speed))},b.prototype.getNavTarget=function(){var b=this,c=b.options.asNavFor;return c&&null!==c&&(c=a(c).not(b.$slider)),c},b.prototype.asNavFor=function(b){var c=this,d=c.getNavTarget();null!==d&&"object"==typeof d&&d.each(function(){var c=a(this).slick("getSlick");c.unslicked||c.slideHandler(b,!0)})},b.prototype.applyTransition=function(a){var b=this,c={};b.options.fade===!1?c[b.transitionType]=b.transformType+" "+b.options.speed+"ms "+b.options.cssEase:c[b.transitionType]="opacity "+b.options.speed+"ms "+b.options.cssEase,b.options.fade===!1?b.$slideTrack.css(c):b.$slides.eq(a).css(c)},b.prototype.autoPlay=function(){var a=this;a.autoPlayClear(),a.slideCount>a.options.slidesToShow&&(a.autoPlayTimer=setInterval(a.autoPlayIterator,a.options.autoplaySpeed))},b.prototype.autoPlayClear=function(){var a=this;a.autoPlayTimer&&clearInterval(a.autoPlayTimer)},b.prototype.autoPlayIterator=function(){var a=this,b=a.currentSlide+a.options.slidesToScroll;a.paused||a.interrupted||a.focussed||(a.options.infinite===!1&&(1===a.direction&&a.currentSlide+1===a.slideCount-1?a.direction=0:0===a.direction&&(b=a.currentSlide-a.options.slidesToScroll,a.currentSlide-1===0&&(a.direction=1))),a.slideHandler(b))},b.prototype.buildArrows=function(){var b=this;b.options.arrows===!0&&(b.$prevArrow=a(b.options.prevArrow).addClass("slick-arrow"),b.$nextArrow=a(b.options.nextArrow).addClass("slick-arrow"),b.slideCount>b.options.slidesToShow?(b.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),b.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),b.htmlExpr.test(b.options.prevArrow)&&b.$prevArrow.prependTo(b.options.appendArrows),b.htmlExpr.test(b.options.nextArrow)&&b.$nextArrow.appendTo(b.options.appendArrows),b.options.infinite!==!0&&b.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):b.$prevArrow.add(b.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},b.prototype.buildDots=function(){var c,d,b=this;if(b.options.dots===!0&&b.slideCount>b.options.slidesToShow){for(b.$slider.addClass("slick-dotted"),d=a("<ul />").addClass(b.options.dotsClass),c=0;c<=b.getDotCount();c+=1)d.append(a("<li />").append(b.options.customPaging.call(this,b,c)));b.$dots=d.appendTo(b.options.appendDots),b.$dots.find("li").first().addClass("slick-active").attr("aria-hidden","false")}},b.prototype.buildOut=function(){var b=this;b.$slides=b.$slider.children(b.options.slide+":not(.slick-cloned)").addClass("slick-slide"),b.slideCount=b.$slides.length,b.$slides.each(function(b,c){a(c).attr("data-slick-index",b).data("originalStyling",a(c).attr("style")||"")}),b.$slider.addClass("slick-slider"),b.$slideTrack=0===b.slideCount?a('<div class="slick-track"/>').appendTo(b.$slider):b.$slides.wrapAll('<div class="slick-track"/>').parent(),b.$list=b.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent(),b.$slideTrack.css("opacity",0),(b.options.centerMode===!0||b.options.swipeToSlide===!0)&&(b.options.slidesToScroll=1),a("img[data-lazy]",b.$slider).not("[src]").addClass("slick-loading"),b.setupInfinite(),b.buildArrows(),b.buildDots(),b.updateDots(),b.setSlideClasses("number"==typeof b.currentSlide?b.currentSlide:0),b.options.draggable===!0&&b.$list.addClass("draggable")},b.prototype.buildRows=function(){var b,c,d,e,f,g,h,a=this;if(e=document.createDocumentFragment(),g=a.$slider.children(),a.options.rows>1){for(h=a.options.slidesPerRow*a.options.rows,f=Math.ceil(g.length/h),b=0;f>b;b++){var i=document.createElement("div");for(c=0;c<a.options.rows;c++){var j=document.createElement("div");for(d=0;d<a.options.slidesPerRow;d++){var k=b*h+(c*a.options.slidesPerRow+d);g.get(k)&&j.appendChild(g.get(k))}i.appendChild(j)}e.appendChild(i)}a.$slider.empty().append(e),a.$slider.children().children().children().css({width:100/a.options.slidesPerRow+"%",display:"inline-block"})}},b.prototype.checkResponsive=function(b,c){var e,f,g,d=this,h=!1,i=d.$slider.width(),j=window.innerWidth||a(window).width();if("window"===d.respondTo?g=j:"slider"===d.respondTo?g=i:"min"===d.respondTo&&(g=Math.min(j,i)),d.options.responsive&&d.options.responsive.length&&null!==d.options.responsive){f=null;for(e in d.breakpoints)d.breakpoints.hasOwnProperty(e)&&(d.originalSettings.mobileFirst===!1?g<d.breakpoints[e]&&(f=d.breakpoints[e]):g>d.breakpoints[e]&&(f=d.breakpoints[e]));null!==f?null!==d.activeBreakpoint?(f!==d.activeBreakpoint||c)&&(d.activeBreakpoint=f,"unslick"===d.breakpointSettings[f]?d.unslick(f):(d.options=a.extend({},d.originalSettings,d.breakpointSettings[f]),b===!0&&(d.currentSlide=d.options.initialSlide),d.refresh(b)),h=f):(d.activeBreakpoint=f,"unslick"===d.breakpointSettings[f]?d.unslick(f):(d.options=a.extend({},d.originalSettings,d.breakpointSettings[f]),b===!0&&(d.currentSlide=d.options.initialSlide),d.refresh(b)),h=f):null!==d.activeBreakpoint&&(d.activeBreakpoint=null,d.options=d.originalSettings,b===!0&&(d.currentSlide=d.options.initialSlide),d.refresh(b),h=f),b||h===!1||d.$slider.trigger("breakpoint",[d,h])}},b.prototype.changeSlide=function(b,c){var f,g,h,d=this,e=a(b.currentTarget);switch(e.is("a")&&b.preventDefault(),e.is("li")||(e=e.closest("li")),h=d.slideCount%d.options.slidesToScroll!==0,f=h?0:(d.slideCount-d.currentSlide)%d.options.slidesToScroll,b.data.message){case"previous":g=0===f?d.options.slidesToScroll:d.options.slidesToShow-f,d.slideCount>d.options.slidesToShow&&d.slideHandler(d.currentSlide-g,!1,c);break;case"next":g=0===f?d.options.slidesToScroll:f,d.slideCount>d.options.slidesToShow&&d.slideHandler(d.currentSlide+g,!1,c);break;case"index":var i=0===b.data.index?0:b.data.index||e.index()*d.options.slidesToScroll;d.slideHandler(d.checkNavigable(i),!1,c),e.children().trigger("focus");break;default:return}},b.prototype.checkNavigable=function(a){var c,d,b=this;if(c=b.getNavigableIndexes(),d=0,a>c[c.length-1])a=c[c.length-1];else for(var e in c){if(a<c[e]){a=d;break}d=c[e]}return a},b.prototype.cleanUpEvents=function(){var b=this;b.options.dots&&null!==b.$dots&&a("li",b.$dots).off("click.slick",b.changeSlide).off("mouseenter.slick",a.proxy(b.interrupt,b,!0)).off("mouseleave.slick",a.proxy(b.interrupt,b,!1)),b.$slider.off("focus.slick blur.slick"),b.options.arrows===!0&&b.slideCount>b.options.slidesToShow&&(b.$prevArrow&&b.$prevArrow.off("click.slick",b.changeSlide),b.$nextArrow&&b.$nextArrow.off("click.slick",b.changeSlide)),b.$list.off("touchstart.slick mousedown.slick",b.swipeHandler),b.$list.off("touchmove.slick mousemove.slick",b.swipeHandler),b.$list.off("touchend.slick mouseup.slick",b.swipeHandler),b.$list.off("touchcancel.slick mouseleave.slick",b.swipeHandler),b.$list.off("click.slick",b.clickHandler),a(document).off(b.visibilityChange,b.visibility),b.cleanUpSlideEvents(),b.options.accessibility===!0&&b.$list.off("keydown.slick",b.keyHandler),b.options.focusOnSelect===!0&&a(b.$slideTrack).children().off("click.slick",b.selectHandler),a(window).off("orientationchange.slick.slick-"+b.instanceUid,b.orientationChange),a(window).off("resize.slick.slick-"+b.instanceUid,b.resize),a("[draggable!=true]",b.$slideTrack).off("dragstart",b.preventDefault),a(window).off("load.slick.slick-"+b.instanceUid,b.setPosition),a(document).off("ready.slick.slick-"+b.instanceUid,b.setPosition)},b.prototype.cleanUpSlideEvents=function(){var b=this;b.$list.off("mouseenter.slick",a.proxy(b.interrupt,b,!0)),b.$list.off("mouseleave.slick",a.proxy(b.interrupt,b,!1))},b.prototype.cleanUpRows=function(){var b,a=this;a.options.rows>1&&(b=a.$slides.children().children(),b.removeAttr("style"),a.$slider.empty().append(b))},b.prototype.clickHandler=function(a){var b=this;b.shouldClick===!1&&(a.stopImmediatePropagation(),a.stopPropagation(),a.preventDefault())},b.prototype.destroy=function(b){var c=this;c.autoPlayClear(),c.touchObject={},c.cleanUpEvents(),a(".slick-cloned",c.$slider).detach(),c.$dots&&c.$dots.remove(),c.$prevArrow&&c.$prevArrow.length&&(c.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),c.htmlExpr.test(c.options.prevArrow)&&c.$prevArrow.remove()),c.$nextArrow&&c.$nextArrow.length&&(c.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),c.htmlExpr.test(c.options.nextArrow)&&c.$nextArrow.remove()),c.$slides&&(c.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){a(this).attr("style",a(this).data("originalStyling"))}),c.$slideTrack.children(this.options.slide).detach(),c.$slideTrack.detach(),c.$list.detach(),c.$slider.append(c.$slides)),c.cleanUpRows(),c.$slider.removeClass("slick-slider"),c.$slider.removeClass("slick-initialized"),c.$slider.removeClass("slick-dotted"),c.unslicked=!0,b||c.$slider.trigger("destroy",[c])},b.prototype.disableTransition=function(a){var b=this,c={};c[b.transitionType]="",b.options.fade===!1?b.$slideTrack.css(c):b.$slides.eq(a).css(c)},b.prototype.fadeSlide=function(a,b){var c=this;c.cssTransitions===!1?(c.$slides.eq(a).css({zIndex:c.options.zIndex}),c.$slides.eq(a).animate({opacity:1},c.options.speed,c.options.easing,b)):(c.applyTransition(a),c.$slides.eq(a).css({opacity:1,zIndex:c.options.zIndex}),b&&setTimeout(function(){c.disableTransition(a),b.call()},c.options.speed))},b.prototype.fadeSlideOut=function(a){var b=this;b.cssTransitions===!1?b.$slides.eq(a).animate({opacity:0,zIndex:b.options.zIndex-2},b.options.speed,b.options.easing):(b.applyTransition(a),b.$slides.eq(a).css({opacity:0,zIndex:b.options.zIndex-2}))},b.prototype.filterSlides=b.prototype.slickFilter=function(a){var b=this;null!==a&&(b.$slidesCache=b.$slides,b.unload(),b.$slideTrack.children(this.options.slide).detach(),b.$slidesCache.filter(a).appendTo(b.$slideTrack),b.reinit())},b.prototype.focusHandler=function(){var b=this;b.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*:not(.slick-arrow)",function(c){c.stopImmediatePropagation();var d=a(this);setTimeout(function(){b.options.pauseOnFocus&&(b.focussed=d.is(":focus"),b.autoPlay())},0)})},b.prototype.getCurrent=b.prototype.slickCurrentSlide=function(){var a=this;return a.currentSlide},b.prototype.getDotCount=function(){var a=this,b=0,c=0,d=0;if(a.options.infinite===!0)for(;b<a.slideCount;)++d,b=c+a.options.slidesToScroll,c+=a.options.slidesToScroll<=a.options.slidesToShow?a.options.slidesToScroll:a.options.slidesToShow;else if(a.options.centerMode===!0)d=a.slideCount;else if(a.options.asNavFor)for(;b<a.slideCount;)++d,b=c+a.options.slidesToScroll,c+=a.options.slidesToScroll<=a.options.slidesToShow?a.options.slidesToScroll:a.options.slidesToShow;else d=1+Math.ceil((a.slideCount-a.options.slidesToShow)/a.options.slidesToScroll);return d-1},b.prototype.getLeft=function(a){var c,d,f,b=this,e=0;return b.slideOffset=0,d=b.$slides.first().outerHeight(!0),b.options.infinite===!0?(b.slideCount>b.options.slidesToShow&&(b.slideOffset=b.slideWidth*b.options.slidesToShow*-1,e=d*b.options.slidesToShow*-1),b.slideCount%b.options.slidesToScroll!==0&&a+b.options.slidesToScroll>b.slideCount&&b.slideCount>b.options.slidesToShow&&(a>b.slideCount?(b.slideOffset=(b.options.slidesToShow-(a-b.slideCount))*b.slideWidth*-1,e=(b.options.slidesToShow-(a-b.slideCount))*d*-1):(b.slideOffset=b.slideCount%b.options.slidesToScroll*b.slideWidth*-1,e=b.slideCount%b.options.slidesToScroll*d*-1))):a+b.options.slidesToShow>b.slideCount&&(b.slideOffset=(a+b.options.slidesToShow-b.slideCount)*b.slideWidth,e=(a+b.options.slidesToShow-b.slideCount)*d),b.slideCount<=b.options.slidesToShow&&(b.slideOffset=0,e=0),b.options.centerMode===!0&&b.options.infinite===!0?b.slideOffset+=b.slideWidth*Math.floor(b.options.slidesToShow/2)-b.slideWidth:b.options.centerMode===!0&&(b.slideOffset=0,b.slideOffset+=b.slideWidth*Math.floor(b.options.slidesToShow/2)),c=b.options.vertical===!1?a*b.slideWidth*-1+b.slideOffset:a*d*-1+e,b.options.variableWidth===!0&&(f=b.slideCount<=b.options.slidesToShow||b.options.infinite===!1?b.$slideTrack.children(".slick-slide").eq(a):b.$slideTrack.children(".slick-slide").eq(a+b.options.slidesToShow),c=b.options.rtl===!0?f[0]?-1*(b.$slideTrack.width()-f[0].offsetLeft-f.width()):0:f[0]?-1*f[0].offsetLeft:0,b.options.centerMode===!0&&(f=b.slideCount<=b.options.slidesToShow||b.options.infinite===!1?b.$slideTrack.children(".slick-slide").eq(a):b.$slideTrack.children(".slick-slide").eq(a+b.options.slidesToShow+1),c=b.options.rtl===!0?f[0]?-1*(b.$slideTrack.width()-f[0].offsetLeft-f.width()):0:f[0]?-1*f[0].offsetLeft:0,c+=(b.$list.width()-f.outerWidth())/2)),c},b.prototype.getOption=b.prototype.slickGetOption=function(a){var b=this;return b.options[a]},b.prototype.getNavigableIndexes=function(){var e,a=this,b=0,c=0,d=[];for(a.options.infinite===!1?e=a.slideCount:(b=-1*a.options.slidesToScroll,c=-1*a.options.slidesToScroll,e=2*a.slideCount);e>b;)d.push(b),b=c+a.options.slidesToScroll,c+=a.options.slidesToScroll<=a.options.slidesToShow?a.options.slidesToScroll:a.options.slidesToShow;return d},b.prototype.getSlick=function(){return this},b.prototype.getSlideCount=function(){var c,d,e,b=this;return e=b.options.centerMode===!0?b.slideWidth*Math.floor(b.options.slidesToShow/2):0,b.options.swipeToSlide===!0?(b.$slideTrack.find(".slick-slide").each(function(c,f){return f.offsetLeft-e+a(f).outerWidth()/2>-1*b.swipeLeft?(d=f,!1):void 0}),c=Math.abs(a(d).attr("data-slick-index")-b.currentSlide)||1):b.options.slidesToScroll},b.prototype.goTo=b.prototype.slickGoTo=function(a,b){var c=this;c.changeSlide({data:{message:"index",index:parseInt(a)}},b)},b.prototype.init=function(b){var c=this;a(c.$slider).hasClass("slick-initialized")||(a(c.$slider).addClass("slick-initialized"),c.buildRows(),c.buildOut(),c.setProps(),c.startLoad(),c.loadSlider(),c.initializeEvents(),c.updateArrows(),c.updateDots(),c.checkResponsive(!0),c.focusHandler()),b&&c.$slider.trigger("init",[c]),c.options.accessibility===!0&&c.initADA(),c.options.autoplay&&(c.paused=!1,c.autoPlay())},b.prototype.initADA=function(){var b=this;b.$slides.add(b.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),b.$slideTrack.attr("role","listbox"),b.$slides.not(b.$slideTrack.find(".slick-cloned")).each(function(c){a(this).attr({role:"option","aria-describedby":"slick-slide"+b.instanceUid+c})}),null!==b.$dots&&b.$dots.attr("role","tablist").find("li").each(function(c){a(this).attr({role:"presentation","aria-selected":"false","aria-controls":"navigation"+b.instanceUid+c,id:"slick-slide"+b.instanceUid+c})}).first().attr("aria-selected","true").end().find("button").attr("role","button").end().closest("div").attr("role","toolbar"),b.activateADA()},b.prototype.initArrowEvents=function(){var a=this;a.options.arrows===!0&&a.slideCount>a.options.slidesToShow&&(a.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},a.changeSlide),a.$nextArrow.off("click.slick").on("click.slick",{message:"next"},a.changeSlide))},b.prototype.initDotEvents=function(){var b=this;b.options.dots===!0&&b.slideCount>b.options.slidesToShow&&a("li",b.$dots).on("click.slick",{message:"index"},b.changeSlide),b.options.dots===!0&&b.options.pauseOnDotsHover===!0&&a("li",b.$dots).on("mouseenter.slick",a.proxy(b.interrupt,b,!0)).on("mouseleave.slick",a.proxy(b.interrupt,b,!1))},b.prototype.initSlideEvents=function(){var b=this;b.options.pauseOnHover&&(b.$list.on("mouseenter.slick",a.proxy(b.interrupt,b,!0)),b.$list.on("mouseleave.slick",a.proxy(b.interrupt,b,!1)))},b.prototype.initializeEvents=function(){var b=this;b.initArrowEvents(),b.initDotEvents(),b.initSlideEvents(),b.$list.on("touchstart.slick mousedown.slick",{action:"start"},b.swipeHandler),b.$list.on("touchmove.slick mousemove.slick",{action:"move"},b.swipeHandler),b.$list.on("touchend.slick mouseup.slick",{action:"end"},b.swipeHandler),b.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},b.swipeHandler),b.$list.on("click.slick",b.clickHandler),a(document).on(b.visibilityChange,a.proxy(b.visibility,b)),b.options.accessibility===!0&&b.$list.on("keydown.slick",b.keyHandler),b.options.focusOnSelect===!0&&a(b.$slideTrack).children().on("click.slick",b.selectHandler),a(window).on("orientationchange.slick.slick-"+b.instanceUid,a.proxy(b.orientationChange,b)),a(window).on("resize.slick.slick-"+b.instanceUid,a.proxy(b.resize,b)),a("[draggable!=true]",b.$slideTrack).on("dragstart",b.preventDefault),a(window).on("load.slick.slick-"+b.instanceUid,b.setPosition),a(document).on("ready.slick.slick-"+b.instanceUid,b.setPosition)},b.prototype.initUI=function(){var a=this;a.options.arrows===!0&&a.slideCount>a.options.slidesToShow&&(a.$prevArrow.show(),a.$nextArrow.show()),a.options.dots===!0&&a.slideCount>a.options.slidesToShow&&a.$dots.show()},b.prototype.keyHandler=function(a){var b=this;a.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===a.keyCode&&b.options.accessibility===!0?b.changeSlide({data:{message:b.options.rtl===!0?"next":"previous"}}):39===a.keyCode&&b.options.accessibility===!0&&b.changeSlide({data:{message:b.options.rtl===!0?"previous":"next"}}))},b.prototype.lazyLoad=function(){function g(c){a("img[data-lazy]",c).each(function(){var c=a(this),d=a(this).attr("data-lazy"),e=document.createElement("img");e.onload=function(){c.animate({opacity:0},100,function(){c.attr("src",d).animate({opacity:1},200,function(){c.removeAttr("data-lazy").removeClass("slick-loading")}),b.$slider.trigger("lazyLoaded",[b,c,d])})},e.onerror=function(){c.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),b.$slider.trigger("lazyLoadError",[b,c,d])},e.src=d})}var c,d,e,f,b=this;b.options.centerMode===!0?b.options.infinite===!0?(e=b.currentSlide+(b.options.slidesToShow/2+1),f=e+b.options.slidesToShow+2):(e=Math.max(0,b.currentSlide-(b.options.slidesToShow/2+1)),f=2+(b.options.slidesToShow/2+1)+b.currentSlide):(e=b.options.infinite?b.options.slidesToShow+b.currentSlide:b.currentSlide,f=Math.ceil(e+b.options.slidesToShow),b.options.fade===!0&&(e>0&&e--,f<=b.slideCount&&f++)),c=b.$slider.find(".slick-slide").slice(e,f),g(c),b.slideCount<=b.options.slidesToShow?(d=b.$slider.find(".slick-slide"),g(d)):b.currentSlide>=b.slideCount-b.options.slidesToShow?(d=b.$slider.find(".slick-cloned").slice(0,b.options.slidesToShow),g(d)):0===b.currentSlide&&(d=b.$slider.find(".slick-cloned").slice(-1*b.options.slidesToShow),g(d))},b.prototype.loadSlider=function(){var a=this;a.setPosition(),a.$slideTrack.css({opacity:1}),a.$slider.removeClass("slick-loading"),a.initUI(),"progressive"===a.options.lazyLoad&&a.progressiveLazyLoad()},b.prototype.next=b.prototype.slickNext=function(){var a=this;a.changeSlide({data:{message:"next"}})},b.prototype.orientationChange=function(){var a=this;a.checkResponsive(),a.setPosition()},b.prototype.pause=b.prototype.slickPause=function(){var a=this;a.autoPlayClear(),a.paused=!0},b.prototype.play=b.prototype.slickPlay=function(){var a=this;a.autoPlay(),a.options.autoplay=!0,a.paused=!1,a.focussed=!1,a.interrupted=!1},b.prototype.postSlide=function(a){var b=this;b.unslicked||(b.$slider.trigger("afterChange",[b,a]),b.animating=!1,b.setPosition(),b.swipeLeft=null,b.options.autoplay&&b.autoPlay(),b.options.accessibility===!0&&b.initADA())},b.prototype.prev=b.prototype.slickPrev=function(){var a=this;a.changeSlide({data:{message:"previous"}})},b.prototype.preventDefault=function(a){a.preventDefault()},b.prototype.progressiveLazyLoad=function(b){b=b||1;var e,f,g,c=this,d=a("img[data-lazy]",c.$slider);d.length?(e=d.first(),f=e.attr("data-lazy"),g=document.createElement("img"),g.onload=function(){e.attr("src",f).removeAttr("data-lazy").removeClass("slick-loading"),c.options.adaptiveHeight===!0&&c.setPosition(),c.$slider.trigger("lazyLoaded",[c,e,f]),c.progressiveLazyLoad()},g.onerror=function(){3>b?setTimeout(function(){c.progressiveLazyLoad(b+1)},500):(e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),c.$slider.trigger("lazyLoadError",[c,e,f]),c.progressiveLazyLoad())},g.src=f):c.$slider.trigger("allImagesLoaded",[c])},b.prototype.refresh=function(b){var d,e,c=this;e=c.slideCount-c.options.slidesToShow,!c.options.infinite&&c.currentSlide>e&&(c.currentSlide=e),c.slideCount<=c.options.slidesToShow&&(c.currentSlide=0),d=c.currentSlide,c.destroy(!0),a.extend(c,c.initials,{currentSlide:d}),c.init(),b||c.changeSlide({data:{message:"index",index:d}},!1)},b.prototype.registerBreakpoints=function(){var c,d,e,b=this,f=b.options.responsive||null;if("array"===a.type(f)&&f.length){b.respondTo=b.options.respondTo||"window";for(c in f)if(e=b.breakpoints.length-1,d=f[c].breakpoint,f.hasOwnProperty(c)){for(;e>=0;)b.breakpoints[e]&&b.breakpoints[e]===d&&b.breakpoints.splice(e,1),e--;b.breakpoints.push(d),b.breakpointSettings[d]=f[c].settings}b.breakpoints.sort(function(a,c){return b.options.mobileFirst?a-c:c-a})}},b.prototype.reinit=function(){var b=this;b.$slides=b.$slideTrack.children(b.options.slide).addClass("slick-slide"),b.slideCount=b.$slides.length,b.currentSlide>=b.slideCount&&0!==b.currentSlide&&(b.currentSlide=b.currentSlide-b.options.slidesToScroll),b.slideCount<=b.options.slidesToShow&&(b.currentSlide=0),b.registerBreakpoints(),b.setProps(),b.setupInfinite(),b.buildArrows(),b.updateArrows(),b.initArrowEvents(),b.buildDots(),b.updateDots(),b.initDotEvents(),b.cleanUpSlideEvents(),b.initSlideEvents(),b.checkResponsive(!1,!0),b.options.focusOnSelect===!0&&a(b.$slideTrack).children().on("click.slick",b.selectHandler),b.setSlideClasses("number"==typeof b.currentSlide?b.currentSlide:0),b.setPosition(),b.focusHandler(),b.paused=!b.options.autoplay,b.autoPlay(),b.$slider.trigger("reInit",[b])},b.prototype.resize=function(){var b=this;a(window).width()!==b.windowWidth&&(clearTimeout(b.windowDelay),b.windowDelay=window.setTimeout(function(){b.windowWidth=a(window).width(),b.checkResponsive(),b.unslicked||b.setPosition()},50))},b.prototype.removeSlide=b.prototype.slickRemove=function(a,b,c){var d=this;return"boolean"==typeof a?(b=a,a=b===!0?0:d.slideCount-1):a=b===!0?--a:a,d.slideCount<1||0>a||a>d.slideCount-1?!1:(d.unload(),c===!0?d.$slideTrack.children().remove():d.$slideTrack.children(this.options.slide).eq(a).remove(),d.$slides=d.$slideTrack.children(this.options.slide),d.$slideTrack.children(this.options.slide).detach(),d.$slideTrack.append(d.$slides),d.$slidesCache=d.$slides,void d.reinit())},b.prototype.setCSS=function(a){var d,e,b=this,c={};b.options.rtl===!0&&(a=-a),d="left"==b.positionProp?Math.ceil(a)+"px":"0px",e="top"==b.positionProp?Math.ceil(a)+"px":"0px",c[b.positionProp]=a,b.transformsEnabled===!1?b.$slideTrack.css(c):(c={},b.cssTransitions===!1?(c[b.animType]="translate("+d+", "+e+")",b.$slideTrack.css(c)):(c[b.animType]="translate3d("+d+", "+e+", 0px)",b.$slideTrack.css(c)))},b.prototype.setDimensions=function(){var a=this;a.options.vertical===!1?a.options.centerMode===!0&&a.$list.css({padding:"0px "+a.options.centerPadding}):(a.$list.height(a.$slides.first().outerHeight(!0)*a.options.slidesToShow),a.options.centerMode===!0&&a.$list.css({padding:a.options.centerPadding+" 0px"})),a.listWidth=a.$list.width(),a.listHeight=a.$list.height(),a.options.vertical===!1&&a.options.variableWidth===!1?(a.slideWidth=Math.ceil(a.listWidth/a.options.slidesToShow),a.$slideTrack.width(Math.ceil(a.slideWidth*a.$slideTrack.children(".slick-slide").length))):a.options.variableWidth===!0?a.$slideTrack.width(5e3*a.slideCount):(a.slideWidth=Math.ceil(a.listWidth),a.$slideTrack.height(Math.ceil(a.$slides.first().outerHeight(!0)*a.$slideTrack.children(".slick-slide").length)));var b=a.$slides.first().outerWidth(!0)-a.$slides.first().width();a.options.variableWidth===!1&&a.$slideTrack.children(".slick-slide").width(a.slideWidth-b)},b.prototype.setFade=function(){var c,b=this;b.$slides.each(function(d,e){c=b.slideWidth*d*-1,b.options.rtl===!0?a(e).css({position:"relative",right:c,top:0,zIndex:b.options.zIndex-2,opacity:0}):a(e).css({position:"relative",left:c,top:0,zIndex:b.options.zIndex-2,opacity:0})}),b.$slides.eq(b.currentSlide).css({zIndex:b.options.zIndex-1,opacity:1})},b.prototype.setHeight=function(){var a=this;if(1===a.options.slidesToShow&&a.options.adaptiveHeight===!0&&a.options.vertical===!1){var b=a.$slides.eq(a.currentSlide).outerHeight(!0);a.$list.css("height",b)}},b.prototype.setOption=b.prototype.slickSetOption=function(){var c,d,e,f,h,b=this,g=!1;if("object"===a.type(arguments[0])?(e=arguments[0],g=arguments[1],h="multiple"):"string"===a.type(arguments[0])&&(e=arguments[0],f=arguments[1],g=arguments[2],"responsive"===arguments[0]&&"array"===a.type(arguments[1])?h="responsive":"undefined"!=typeof arguments[1]&&(h="single")),"single"===h)b.options[e]=f;else if("multiple"===h)a.each(e,function(a,c){b.options[a]=c});else if("responsive"===h)for(d in f)if("array"!==a.type(b.options.responsive))b.options.responsive=[f[d]];else{for(c=b.options.responsive.length-1;c>=0;)b.options.responsive[c].breakpoint===f[d].breakpoint&&b.options.responsive.splice(c,1),c--;b.options.responsive.push(f[d])}g&&(b.unload(),b.reinit())},b.prototype.setPosition=function(){var a=this;a.setDimensions(),a.setHeight(),a.options.fade===!1?a.setCSS(a.getLeft(a.currentSlide)):a.setFade(),a.$slider.trigger("setPosition",[a])},b.prototype.setProps=function(){var a=this,b=document.body.style;a.positionProp=a.options.vertical===!0?"top":"left","top"===a.positionProp?a.$slider.addClass("slick-vertical"):a.$slider.removeClass("slick-vertical"),(void 0!==b.WebkitTransition||void 0!==b.MozTransition||void 0!==b.msTransition)&&a.options.useCSS===!0&&(a.cssTransitions=!0),a.options.fade&&("number"==typeof a.options.zIndex?a.options.zIndex<3&&(a.options.zIndex=3):a.options.zIndex=a.defaults.zIndex),void 0!==b.OTransform&&(a.animType="OTransform",a.transformType="-o-transform",a.transitionType="OTransition",void 0===b.perspectiveProperty&&void 0===b.webkitPerspective&&(a.animType=!1)),void 0!==b.MozTransform&&(a.animType="MozTransform",a.transformType="-moz-transform",a.transitionType="MozTransition",void 0===b.perspectiveProperty&&void 0===b.MozPerspective&&(a.animType=!1)),void 0!==b.webkitTransform&&(a.animType="webkitTransform",a.transformType="-webkit-transform",a.transitionType="webkitTransition",void 0===b.perspectiveProperty&&void 0===b.webkitPerspective&&(a.animType=!1)),void 0!==b.msTransform&&(a.animType="msTransform",a.transformType="-ms-transform",a.transitionType="msTransition",void 0===b.msTransform&&(a.animType=!1)),void 0!==b.transform&&a.animType!==!1&&(a.animType="transform",a.transformType="transform",a.transitionType="transition"),a.transformsEnabled=a.options.useTransform&&null!==a.animType&&a.animType!==!1},b.prototype.setSlideClasses=function(a){var c,d,e,f,b=this;d=b.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),b.$slides.eq(a).addClass("slick-current"),b.options.centerMode===!0?(c=Math.floor(b.options.slidesToShow/2),b.options.infinite===!0&&(a>=c&&a<=b.slideCount-1-c?b.$slides.slice(a-c,a+c+1).addClass("slick-active").attr("aria-hidden","false"):(e=b.options.slidesToShow+a,
d.slice(e-c+1,e+c+2).addClass("slick-active").attr("aria-hidden","false")),0===a?d.eq(d.length-1-b.options.slidesToShow).addClass("slick-center"):a===b.slideCount-1&&d.eq(b.options.slidesToShow).addClass("slick-center")),b.$slides.eq(a).addClass("slick-center")):a>=0&&a<=b.slideCount-b.options.slidesToShow?b.$slides.slice(a,a+b.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):d.length<=b.options.slidesToShow?d.addClass("slick-active").attr("aria-hidden","false"):(f=b.slideCount%b.options.slidesToShow,e=b.options.infinite===!0?b.options.slidesToShow+a:a,b.options.slidesToShow==b.options.slidesToScroll&&b.slideCount-a<b.options.slidesToShow?d.slice(e-(b.options.slidesToShow-f),e+f).addClass("slick-active").attr("aria-hidden","false"):d.slice(e,e+b.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false")),"ondemand"===b.options.lazyLoad&&b.lazyLoad()},b.prototype.setupInfinite=function(){var c,d,e,b=this;if(b.options.fade===!0&&(b.options.centerMode=!1),b.options.infinite===!0&&b.options.fade===!1&&(d=null,b.slideCount>b.options.slidesToShow)){for(e=b.options.centerMode===!0?b.options.slidesToShow+1:b.options.slidesToShow,c=b.slideCount;c>b.slideCount-e;c-=1)d=c-1,a(b.$slides[d]).clone(!0).attr("id","").attr("data-slick-index",d-b.slideCount).prependTo(b.$slideTrack).addClass("slick-cloned");for(c=0;e>c;c+=1)d=c,a(b.$slides[d]).clone(!0).attr("id","").attr("data-slick-index",d+b.slideCount).appendTo(b.$slideTrack).addClass("slick-cloned");b.$slideTrack.find(".slick-cloned").find("[id]").each(function(){a(this).attr("id","")})}},b.prototype.interrupt=function(a){var b=this;a||b.autoPlay(),b.interrupted=a},b.prototype.selectHandler=function(b){var c=this,d=a(b.target).is(".slick-slide")?a(b.target):a(b.target).parents(".slick-slide"),e=parseInt(d.attr("data-slick-index"));return e||(e=0),c.slideCount<=c.options.slidesToShow?(c.setSlideClasses(e),void c.asNavFor(e)):void c.slideHandler(e)},b.prototype.slideHandler=function(a,b,c){var d,e,f,g,j,h=null,i=this;return b=b||!1,i.animating===!0&&i.options.waitForAnimate===!0||i.options.fade===!0&&i.currentSlide===a||i.slideCount<=i.options.slidesToShow?void 0:(b===!1&&i.asNavFor(a),d=a,h=i.getLeft(d),g=i.getLeft(i.currentSlide),i.currentLeft=null===i.swipeLeft?g:i.swipeLeft,i.options.infinite===!1&&i.options.centerMode===!1&&(0>a||a>i.getDotCount()*i.options.slidesToScroll)?void(i.options.fade===!1&&(d=i.currentSlide,c!==!0?i.animateSlide(g,function(){i.postSlide(d)}):i.postSlide(d))):i.options.infinite===!1&&i.options.centerMode===!0&&(0>a||a>i.slideCount-i.options.slidesToScroll)?void(i.options.fade===!1&&(d=i.currentSlide,c!==!0?i.animateSlide(g,function(){i.postSlide(d)}):i.postSlide(d))):(i.options.autoplay&&clearInterval(i.autoPlayTimer),e=0>d?i.slideCount%i.options.slidesToScroll!==0?i.slideCount-i.slideCount%i.options.slidesToScroll:i.slideCount+d:d>=i.slideCount?i.slideCount%i.options.slidesToScroll!==0?0:d-i.slideCount:d,i.animating=!0,i.$slider.trigger("beforeChange",[i,i.currentSlide,e]),f=i.currentSlide,i.currentSlide=e,i.setSlideClasses(i.currentSlide),i.options.asNavFor&&(j=i.getNavTarget(),j=j.slick("getSlick"),j.slideCount<=j.options.slidesToShow&&j.setSlideClasses(i.currentSlide)),i.updateDots(),i.updateArrows(),i.options.fade===!0?(c!==!0?(i.fadeSlideOut(f),i.fadeSlide(e,function(){i.postSlide(e)})):i.postSlide(e),void i.animateHeight()):void(c!==!0?i.animateSlide(h,function(){i.postSlide(e)}):i.postSlide(e))))},b.prototype.startLoad=function(){var a=this;a.options.arrows===!0&&a.slideCount>a.options.slidesToShow&&(a.$prevArrow.hide(),a.$nextArrow.hide()),a.options.dots===!0&&a.slideCount>a.options.slidesToShow&&a.$dots.hide(),a.$slider.addClass("slick-loading")},b.prototype.swipeDirection=function(){var a,b,c,d,e=this;return a=e.touchObject.startX-e.touchObject.curX,b=e.touchObject.startY-e.touchObject.curY,c=Math.atan2(b,a),d=Math.round(180*c/Math.PI),0>d&&(d=360-Math.abs(d)),45>=d&&d>=0?e.options.rtl===!1?"left":"right":360>=d&&d>=315?e.options.rtl===!1?"left":"right":d>=135&&225>=d?e.options.rtl===!1?"right":"left":e.options.verticalSwiping===!0?d>=35&&135>=d?"down":"up":"vertical"},b.prototype.swipeEnd=function(a){var c,d,b=this;if(b.dragging=!1,b.interrupted=!1,b.shouldClick=b.touchObject.swipeLength>10?!1:!0,void 0===b.touchObject.curX)return!1;if(b.touchObject.edgeHit===!0&&b.$slider.trigger("edge",[b,b.swipeDirection()]),b.touchObject.swipeLength>=b.touchObject.minSwipe){switch(d=b.swipeDirection()){case"left":case"down":c=b.options.swipeToSlide?b.checkNavigable(b.currentSlide+b.getSlideCount()):b.currentSlide+b.getSlideCount(),b.currentDirection=0;break;case"right":case"up":c=b.options.swipeToSlide?b.checkNavigable(b.currentSlide-b.getSlideCount()):b.currentSlide-b.getSlideCount(),b.currentDirection=1}"vertical"!=d&&(b.slideHandler(c),b.touchObject={},b.$slider.trigger("swipe",[b,d]))}else b.touchObject.startX!==b.touchObject.curX&&(b.slideHandler(b.currentSlide),b.touchObject={})},b.prototype.swipeHandler=function(a){var b=this;if(!(b.options.swipe===!1||"ontouchend"in document&&b.options.swipe===!1||b.options.draggable===!1&&-1!==a.type.indexOf("mouse")))switch(b.touchObject.fingerCount=a.originalEvent&&void 0!==a.originalEvent.touches?a.originalEvent.touches.length:1,b.touchObject.minSwipe=b.listWidth/b.options.touchThreshold,b.options.verticalSwiping===!0&&(b.touchObject.minSwipe=b.listHeight/b.options.touchThreshold),a.data.action){case"start":b.swipeStart(a);break;case"move":b.swipeMove(a);break;case"end":b.swipeEnd(a)}},b.prototype.swipeMove=function(a){var d,e,f,g,h,b=this;return h=void 0!==a.originalEvent?a.originalEvent.touches:null,!b.dragging||h&&1!==h.length?!1:(d=b.getLeft(b.currentSlide),b.touchObject.curX=void 0!==h?h[0].pageX:a.clientX,b.touchObject.curY=void 0!==h?h[0].pageY:a.clientY,b.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(b.touchObject.curX-b.touchObject.startX,2))),b.options.verticalSwiping===!0&&(b.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(b.touchObject.curY-b.touchObject.startY,2)))),e=b.swipeDirection(),"vertical"!==e?(void 0!==a.originalEvent&&b.touchObject.swipeLength>4&&a.preventDefault(),g=(b.options.rtl===!1?1:-1)*(b.touchObject.curX>b.touchObject.startX?1:-1),b.options.verticalSwiping===!0&&(g=b.touchObject.curY>b.touchObject.startY?1:-1),f=b.touchObject.swipeLength,b.touchObject.edgeHit=!1,b.options.infinite===!1&&(0===b.currentSlide&&"right"===e||b.currentSlide>=b.getDotCount()&&"left"===e)&&(f=b.touchObject.swipeLength*b.options.edgeFriction,b.touchObject.edgeHit=!0),b.options.vertical===!1?b.swipeLeft=d+f*g:b.swipeLeft=d+f*(b.$list.height()/b.listWidth)*g,b.options.verticalSwiping===!0&&(b.swipeLeft=d+f*g),b.options.fade===!0||b.options.touchMove===!1?!1:b.animating===!0?(b.swipeLeft=null,!1):void b.setCSS(b.swipeLeft)):void 0)},b.prototype.swipeStart=function(a){var c,b=this;return b.interrupted=!0,1!==b.touchObject.fingerCount||b.slideCount<=b.options.slidesToShow?(b.touchObject={},!1):(void 0!==a.originalEvent&&void 0!==a.originalEvent.touches&&(c=a.originalEvent.touches[0]),b.touchObject.startX=b.touchObject.curX=void 0!==c?c.pageX:a.clientX,b.touchObject.startY=b.touchObject.curY=void 0!==c?c.pageY:a.clientY,void(b.dragging=!0))},b.prototype.unfilterSlides=b.prototype.slickUnfilter=function(){var a=this;null!==a.$slidesCache&&(a.unload(),a.$slideTrack.children(this.options.slide).detach(),a.$slidesCache.appendTo(a.$slideTrack),a.reinit())},b.prototype.unload=function(){var b=this;a(".slick-cloned",b.$slider).remove(),b.$dots&&b.$dots.remove(),b.$prevArrow&&b.htmlExpr.test(b.options.prevArrow)&&b.$prevArrow.remove(),b.$nextArrow&&b.htmlExpr.test(b.options.nextArrow)&&b.$nextArrow.remove(),b.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},b.prototype.unslick=function(a){var b=this;b.$slider.trigger("unslick",[b,a]),b.destroy()},b.prototype.updateArrows=function(){var b,a=this;b=Math.floor(a.options.slidesToShow/2),a.options.arrows===!0&&a.slideCount>a.options.slidesToShow&&!a.options.infinite&&(a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),a.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===a.currentSlide?(a.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),a.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):a.currentSlide>=a.slideCount-a.options.slidesToShow&&a.options.centerMode===!1?(a.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):a.currentSlide>=a.slideCount-1&&a.options.centerMode===!0&&(a.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},b.prototype.updateDots=function(){var a=this;null!==a.$dots&&(a.$dots.find("li").removeClass("slick-active").attr("aria-hidden","true"),a.$dots.find("li").eq(Math.floor(a.currentSlide/a.options.slidesToScroll)).addClass("slick-active").attr("aria-hidden","false"))},b.prototype.visibility=function(){var a=this;a.options.autoplay&&(document[a.hidden]?a.interrupted=!0:a.interrupted=!1)},a.fn.slick=function(){var f,g,a=this,c=arguments[0],d=Array.prototype.slice.call(arguments,1),e=a.length;for(f=0;e>f;f++)if("object"==typeof c||"undefined"==typeof c?a[f].slick=new b(a[f],c):g=a[f].slick[c].apply(a[f].slick,d),"undefined"!=typeof g)return g;return a}});
(function ($, undefined) {

	'use strict';

	var showMoreBrands = function showMoreBrands() {
		$(this).fadeOut();
		var count = 0;

		$('.portfolio-brands-ctn').find('.portfolio-one-brand.hide').each(function () {
			var t = $(this);
			count++;

			setTimeout(function () {
				t.fadeIn();
			}, count * 400);
		});
	};

	var init = function init() {
		$('.portfolio-show-more-brands-btn').click(showMoreBrands);
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
(function ($, undefined) {

	'use strict';

	var win;
	var winWidth;
	var winHeight;
	var items;

	var autoScreenHeight = function autoScreenHeight() {
		items.each(function () {
			var t = $(this);
			var attr = t.data('autoScreenAttr') === undefined ? 'min-height' : t.attr('data-auto-screen-attr');
			var offset = t.data('autoScreenOffset') !== undefined ? t.data('autoScreenOffset').replace(/\s+/g, '').split(',') : 0;
			var factor = t.data('autoScreenFactor') !== undefined ? t.data('autoScreenFactor') : 1;
			var offsetHeight = 0;

			$.each(offset, function (i) {
				var t = $(offset[i]);
				offsetHeight += t.outerHeight();
			});

			var newHeight = winHeight * factor - offsetHeight;

			t.css(attr, newHeight);
		});
	};

	var init = function init() {
		win = $(window);
		winWidth = win.width();
		winHeight = win.height();
		items = $('.js-auto-screen-height');

		autoScreenHeight();

		win.resize(function () {
			winWidth = win.width();
			winHeight = win.height();

			autoScreenHeight();
		});
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function ($, undefined) {

	'use strict';

	var createSelects = function createSelects() {
		var selects = document.querySelectorAll('select.change-select-js');

		for (var i = 0; i < selects.length; i++) {
			var select = selects[i];
			var options = select.querySelectorAll('option');
			var parent = select.parentNode;
			var newSelect = document.createElement('div');
			var optionsContainer = document.createElement('div');
			var selectedValue = document.createElement('div');
			var optionsValues = '';

			for (var k = 0; k < select.attributes.length; k++) {
				var selectAttr = select.attributes[k];
				selectedValue.setAttribute(selectAttr.name, selectAttr.nodeValue || selectAttr.value);
			}

			newSelect.className = 'select-changed-js';

			optionsContainer.className = 'select-options-container';

			selectedValue.classList.remove('change-select-js');
			selectedValue.classList.add('select-value');
			selectedValue.setAttribute('tabindex', '0');

			for (var j = 0; j < options.length; j++) {
				var option = options[j];
				var newOption = document.createElement('div');
				var value = getValue(option);
				newOption.setAttribute('data-value', value);
				newOption.innerText = option.innerText;

				for (var l = 0; l < option.attributes.length; l++) {
					var optionAttr = option.attributes[l];
					newOption.setAttribute(optionAttr.name, optionAttr.nodeValue || optionAttr.value);
				}

				if (option.selected) {
					selectedValue.innerText = newOption.innerText;
					selectedValue.setAttribute('data-value', value);
					newOption.className = 'select-option selected hover';
				} else {
					newOption.className = 'select-option';
				}

				if (optionsValues.length) {
					optionsValues += '\n';
				}
				optionsValues += option.innerText;

				optionsContainer.appendChild(newOption);
			}

			newSelect.setAttribute('data-items', optionsValues);

			newSelect.appendChild(selectedValue);
			newSelect.appendChild(optionsContainer);
			parent.insertBefore(newSelect, select);
			parent.removeChild(select);

			setupListeners(newSelect, selectedValue, optionsContainer);
		}
	};

	var setupListeners = function setupListeners(newSelect, selectValue, optionsContainer) {
		var options = optionsContainer.querySelectorAll('.select-option');

		selectValue.addEventListener('mousedown', toggleOptionsContainer);
		newSelect.addEventListener('focusin', startListeningForKeys);
		newSelect.addEventListener('focusout', stopListeningForKeys);

		for (var i = 0; i < options.length; i++) {
			var option = options[i];
			option.addEventListener('mouseup', updateSelectedValue);
			option.addEventListener('mouseover', optionOver);
			option.addEventListener('mouseout', optionOver);
		}
	};

	var optionOver = function optionOver(e) {
		if (e.type === 'mouseout') {
			var target = document.elementFromPoint(e.clientX, e.clientY);
			if (target) {
				if (target.classList.contains('select-option')) {
					this.classList.remove('hover');
				}
			}
			this.removeEventListener('mousemove', optionOver);
		} else if (e.type === 'mouseover' || e.type === 'mousemove') {
			var hovered = getHovered(this.parentNode);

			if (e.type === 'mouseover' || hovered !== this) {
				hovered.classList.remove('hover');
				this.classList.add('hover');
			}

			if (e.type === 'mouseover') {
				this.addEventListener('mousemove', optionOver);
			}
		}
	};

	var startListeningForKeys = function startListeningForKeys() {
		window.addEventListener('keydown', selectKeydown);
		this.classList.add('select-focused');
	};

	var stopListeningForKeys = function stopListeningForKeys() {
		window.removeEventListener('keydown', selectKeydown);
		this.classList.remove('select-focused');
	};

	var selectKeydown = function selectKeydown(e) {
		var container = document.querySelector('.select-focused .select-options-container');
		var isOpened = container.classList.contains('show-options');
		var key = getKey(e.code || e.which);

		// Allows for other keys to work as they should
		if (key.isOneOfKeys || isOpened && !key.isOneOfKeys) {
			e.preventDefault();
			e.stopPropagation();

			if (key.code === 'Tab' || key.code === 9) {
				toggleOptionsContainer.apply(container.previousElementSibling);
			}
		}

		if (isOpened) {
			if (key.isEnter || key.isEscape) {
				toggleOptionsContainer.apply(container.previousElementSibling);
			}
		} else {
			if (key.isSpace) {
				toggleOptionsContainer.apply(container.previousElementSibling);
			}
		}

		if (key.isUp) {
			goToPrevValue(container, e);
		} else if (key.isDown) {
			goToNextValue(container, e);
		} else if (key.isKey) {
			goToNextKeyValue(container, e, key.code);
		}
	};

	var toggleOptionsContainer = function toggleOptionsContainer() {
		var options = this.nextElementSibling;
		var currentHover = getHovered(options);
		var currentSelected = getSelected(options);

		options.classList.toggle('show-options');

		currentHover.classList.remove('hover');
		currentSelected.classList.add('hover');

		if (options.classList.contains('show-options')) {
			setTimeout(function () {
				window.addEventListener('mousedown', closeToggled);
			}, 1);
		} else {
			window.removeEventListener('mousedown', closeToggled);
		}
	};

	var closeToggled = function closeToggled(e) {
		var classesRegex = /select-option|select-changed-js|select-value|select-options-container/;
		var target = e.target;
		var isSelect = false;
		if (e.target.className.match(classesRegex)) {
			if (target.classList.contains('select-focused')) {
				isSelect = true;
			} else {
				while (target) {
					if (target.classList.contains('select-focused')) {
						isSelect = true;
						break;
					} else if (!target.className.match(classesRegex)) {
						break;
					}
					target = target.parentNode;
				}
			}
		}

		if (!isSelect) {
			var containers = document.querySelectorAll('.show-options');
			for (var i = 0; i < containers.length; i++) {
				var option = containers[i];
				toggleOptionsContainer.apply(option.previousElementSibling);
			}
		}
	};

	var updateSelectedValue = function updateSelectedValue(e, fromKey) {
		var parent = this.parentNode;
		var select = parent.parentNode;
		var selectedValue = parent.previousElementSibling;
		var previousOption = getSelected(parent);
		var previousOver = getHovered(parent);
		var changeEvent;

		if (typeof window.CustomEvent === 'function') {
			changeEvent = new CustomEvent('change', {
				originalEvent: e,
				type: 'change'
			});
		} else {
			changeEvent = document.createEvent('CustomEvent');
			changeEvent.initCustomEvent('change', true, true, {
				originalEvent: e,
				type: 'change'
			});
		}

		e.preventDefault();

		previousOption.classList.remove('selected');
		this.classList.add('selected');

		selectedValue.setAttribute('data-value', this.getAttribute('data-value'));
		selectedValue.innerHTML = this.innerHTML;

		if (!fromKey) {
			toggleOptionsContainer.apply(selectedValue);
		} else {
			parent.scrollTop = this.offsetTop;
			previousOver.classList.remove('hover');
			this.classList.add('hover');
		}

		if (selectedValue.dispatchEvent) {
			selectedValue.dispatchEvent(changeEvent);
		} else {
			selectedValue.fireEvent(changeEvent);
		}
	};

	var goToPrevValue = function goToPrevValue(container, e) {
		var hover = getHovered(container);
		var prev = hover.previousElementSibling;

		if (prev) {
			updateSelectedValue.apply(prev, [e, true]);
		}
	};

	var goToNextValue = function goToNextValue(container, e) {
		var hover = getHovered(container);
		var next = hover.nextElementSibling;

		if (next) {
			updateSelectedValue.apply(next, [e, true]);
		}
	};

	var goToNextKeyValue = function goToNextKeyValue(container, e, key) {
		var hover = getHovered(container);
		var options = container.querySelectorAll('.select-option');
		var found = false;
		var isNumber = !isNaN(key);
		var keyReplaced = isNumber ? 'asdsadas' : key.replace(/Key|Digit/, '');
		var next = hover;

		for (var i = 0; i < options.length; i++) {
			next = next.nextElementSibling;

			if (!next) {
				next = container.children[0];
			}

			if (isNumber) {
				if (next.innerHTML.charCodeAt(0) === key) {
					found = true;
					break;
				}
			} else {
				if (next.innerHTML.charAt(0).toUpperCase() === keyReplaced) {
					found = true;
					break;
				}
			}
		}

		if (found) {
			updateSelectedValue.apply(next, [e, true]);
		}
	};

	var getValue = function getValue(option) {
		if (!option.hasAttribute('value')) {
			return option.innerText;
		} else {
			return option.getAttribute('value');
		}
	};

	var getKey = function getKey(key) {
		var data = {
			code: key,
			isEnter: false,
			isKey: false,
			isEscape: false,
			isSpace: false,
			isUp: false,
			isDown: false,
			isOneOfKeys: false,
			keyValue: undefined
		};
		var isNumber = key >= 48 && key <= 57;
		var isLetter = key >= 65 && key <= 90;

		if (key === 13 || key === 'Enter') {
			data.isEnter = true;
		} else if (key === 27 || key === 'Escape') {
			data.isEscape = true;
		} else if (key === 32 || key === ' ' || key === 'Space') {
			data.isSpace = true;
		} else if (key === 38 || key === 37 || key === 'ArrowLeft' || key === 'ArrowUp') {
			data.isUp = true;
		} else if (key === 40 || key === 39 || key === 'ArrowRight' || key === 'ArrowDown') {
			data.isDown = true;
		} else if (isNumber || isLetter || /[a-z0-9]{1}/i.test(key) && key.length === 1 || /(Key[A-Z])|(Digit[0-9])/.test(key)) {
			data.isKey = true;

			if (isNumber || isLetter) {
				keyValue = String.fromCharCode(key);
			} else {
				keyValue = key;
			}
		}

		if (data.isEnter || data.isEscape || data.isSpace || data.isUp || data.isDown || data.isKey) {
			data.isOneOfKeys = true;
		}

		return data;
	};

	var getHovered = function getHovered(container) {
		var hover = container.querySelector('.hover');

		if (!hover) {
			hover = container.querySelector('.select-option');
		}

		return hover;
	};

	var getSelected = function getSelected(container) {
		var selected = container.querySelector('.selected');

		if (!selected) {
			selected = container.querySelector('.select-option');
		}

		return selected;
	};

	var getSelectValue = function getSelectValue(selectCtn) {
		var selectItem;
		if (typeof selectCtn === 'string') {
			selectItem = document.querySelector(selectCtn);
			if (!selectItem) {
				return null;
			}
		} else if ((typeof selectCtn === 'undefined' ? 'undefined' : _typeof(selectCtn)) === 'object') {
			if (selectCtn[0]) {
				selectItem = selectCtn[0];
			} else {
				return null;
			}
		} else if (selectCtn && selectCtn.nodeType) {
			selectItem = selectCtn;
		} else {
			return null;
		}

		try {
			return selectItem.querySelector('.select-value').getAttribute('data-value');
		} catch (ex) {
			console.error(ex);
			return null;
		}
	};

	$(document).ready(function () {
		createSelects();
	});

	var customSelect = Fw.component.export('customSelect', {
		val: getSelectValue
	});
})(jQuery);
(function ($, undefined) {

	'use strict';

	var init = function init() {
		if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
			$('html').addClass('mobile');
		}
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
(function ($, undefined) {

	'use strict';

	var editableText;

	var moveEditableText = function moveEditableText() {
		var text = $('.editable-text-ctn');

		text.each(function () {
			var t = $(this);
			var ctn = t.parent('.js-editable-container');
			var pos;
			var receiver;

			if (t.attr('data-position') !== 0) {
				pos = t.attr('data-position');
			} else {
				pos = 1;
			}

			if ($('.js-editable-receiver[data-editable-receiver-position = ' + pos + ']', ctn).length !== 0) {
				receiver = $('.js-editable-receiver[data-editable-receiver-position = ' + pos + ']', ctn);
			} else {
				receiver = $('.js-editable-receiver', ctn);
			}

			if ($('.js-editable-receiver[data-editable-receiver-position]', ctn).length !== 0 && $('.js-editable-receiver[data-editable-receiver-position = ' + pos + ']', ctn).length === 0 && t.attr('data-position') !== '') {
				t.remove();
			} else if (ctn.length !== 0 && receiver.length !== 0) {
				t.detach().appendTo(receiver);
			}
		});
	};

	var addEditableTextClass = function addEditableTextClass() {
		$('.componentContainerDiv').addClass('js-editable-container');

		editableText.each(function () {
			var t = $(this);
			var parent = t.parent();

			parent.addClass('editable-text-ctn');
		});
	};

	var addEditableTextPosition = function addEditableTextPosition() {
		$('.js-editable-container').each(function () {
			var index = 1;
			var t = $(this);

			$('.editable-text-ctn', t).each(function () {
				var t = $(this);

				t.attr('data-position', index);

				index++;
			});
		});
	};

	var init = function init() {
		editableText = $('div[id^=displayTextInnerWindow]');

		addEditableTextClass();
		addEditableTextPosition();
		moveEditableText();
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
(function ($, undefined) {

	'use strict';

	var addExternalLinkTarget = function addExternalLinkTarget() {
		$.expr[':'].external = function (obj) {
			var hostname = obj.hostname === '' ? location.hostname : obj.hostname;

			return !obj.href.match(/^mailto\:/) && hostname != location.hostname && !obj.href.match(/^javascript\:/) && !obj.href.match(/^tel\:/) && !obj.href.match(/^$/) || obj.href.match(/\.pdf$/);
		};

		$('a:external').attr('target', '_blank');
	};

	var init = function init() {
		addExternalLinkTarget();
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
/*
*   Google Maps librairy - MG2 Media
*   @author Mathilde Paccoud & François Vandal
*   @version: 0.5
*   Last update: 8/11/2017
*/

(function ($, global, undefined) {

    'use strict';

    var win = $(window);
    var winWidth;

    var counter = 0;
    var distance = 15;
    var maxResults = 25;
    var eleMaps;
    var loadings;
    var mapsList = {};
    var currInfoOpen = '';
    var lang = $('html').attr('lang');
    var isUnderSm = true;

    var markerDefault = {
        imageName: 'map-marker.png'
    };

    var defaults = {
        latitude: 45.50867,
        longitude: -73.553992,
        zoom: 16,
        scrollwheel: false,
        getLocalMarker: true,
        getAjaxMarkerList: false,
        ajaxMarkerListDistance: 15,
        ajaxMarkerListMaxResults: 25,
        ajaxReloadOnClick: true,
        panX: 0,
        panY: 0,
        panMinWidth: 0
    };

    var getUrlVars = function getUrlVars() {
        var vars = [],
            hash;
        if (window.location.href.indexOf('?') !== -1) {
            var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
            for (var i = 0; i < hashes.length; i++) {
                hash = hashes[i].split('=');
                //vars.push(hash[0]);
                vars[hash[0]] = hash[1];
            }
            return vars;
        } else {
            return [];
        }
    };

    var centerMapByCoor = function centerMapByCoor(map, myLatlng) {
        map.setCenter(myLatlng);
    };

    var getMarkers = function getMarkers(mapClass, distance, maxResults, element) {
        var currMap = mapsList[mapClass].theMap;
        var mapCenter = currMap.getCenter();
        var mapCenterLat = mapCenter.lat();
        var mapCenterLng = mapCenter.lng();
        var loadingCtn = element.siblings('.gmap-loading');
        var loading = $('.gmap-loading-item', loadingCtn);

        var obj = ajax('/action/getOrganizations?lat=' + mapCenterLat + '&lng=' + mapCenterLng + '&distance=' + distance + '&maxResults=' + maxResults, function (response) {
            getJson(response, mapClass, element, loading);
        }, true);
    };

    var getJson = function getJson(response, mapClass, element, loading) {
        var obj = JSON.parse(response.trim());
        var markersArray = [];

        var tempTotal = 0;
        for (var i = 0; i < obj.length; i++) {
            var exists = false;
            var id = obj[i].id;
            var lat = obj[i].lat;
            var lng = obj[i].lng;
            var name = decodeText(obj[i].name);
            var point = new google.maps.LatLng(lat, lng);
            for (var x = 0; x < markersArray.length; x++) {
                if (markersArray[x][0].getPosition().equals(point) && markersArray[x][1] == name) {
                    exists = true;
                }
            }
            var address = decodeText(obj[i].address);
            var city = decodeText(obj[i].city);
            var postalCode = decodeText(obj[i].postalCode);
            var province = decodeText(obj[i].province);
            var markerName = decodeText(obj[i].field1);
            if (!exists && lat !== 0 && lat !== '' && lng !== 0 && lng !== '') {
                markerName = encodeText(markerName);
                addMarkerInner(id, lat, lng, name, address, city, postalCode, province, markerName, mapClass, element, markersArray);
            }
        }

        mapsList[mapClass] = $.extend(mapsList[mapClass], { markers: markersArray });

        loading.fadeOut(3000);
        setMapBound(mapClass);
    };

    var addMarkerInner = function addMarkerInner(id, lat, lng, title, markerName, mapClass, element, markersArray) {
        var currMap = mapsList[mapClass].theMap;

        var markerOptions = {
            imageName: element.data('makerName'),
            btnValue: element.data('popupBtnValue'),
            btnUrlBeforeId: element.data('popupUrlBeforeId')
        };

        var markerSettings = $.extend({}, markerDefault, markerOptions);

        var myLatlng = new google.maps.LatLng(lat, lng);

        var marker = new google.maps.Marker({
            position: myLatlng,
            title: name,
            icon: '/static/assets/img/' + markerSettings.imageName
        });
        markersArray.push([marker, name]);

        marker.setMap(currMap);
    };

    var clusterIt = function clusterIt(map) {
        var mc = new MarkerClusterer(map, markersArray);
    };

    var addSingleMarkers = function addSingleMarkers(obj, mapClass, myLatlng, loading, settings) {
        var currMap = mapsList[mapClass].theMap;

        var markerOptions = {
            imageName: obj.data('markerName')
        };

        var markerSettings = $.extend({}, markerDefault, markerOptions);

        var marker = new google.maps.Marker({
            position: myLatlng,
            title: obj.data('name'),
            icon: '/static/assets/img/' + markerSettings.imageName
        });

        marker.setMap(currMap);

        mapsList[mapClass] = $.extend(mapsList[mapClass], { markers: marker });

        loading.fadeOut(3000);
    };

    var createMaps = function createMaps() {
        eleMaps.each(function () {
            var t = $(this);
            var addedClass;

            if (t.attr('id') !== 0) {
                addedClass = t.attr('id');
            } else {
                addedClass = 'map-created-' + t.index();
                t.attr('id', addedClass);
            }

            var options = {
                latitude: t.data('latitude'),
                longitude: t.data('longitude'),
                zoom: t.data('zoom'),
                scrollwheel: t.data('scrollwheel'),
                getLocalMarker: t.data('getLocalMarker'),
                getAjaxMarkerList: t.data('getAjaxMarkerList'),
                ajaxMarkerListDistance: t.data('ajaxMarkerListDistance'),
                ajaxMarkerListMaxResults: t.data('ajaxMarkerListMaxResults'),
                ajaxReloadOnIdle: t.data('ajaxReloadOnIdle'),
                panX: t.data('panX'),
                panY: t.data('panY'),
                panMinWidth: t.data('panMinWidth'),
                disableDefaultUI: true
            };

            var settings = $.extend({}, defaults, options);

            var htmlSaveOverflow = $('html').css('overflow');
            $('html').css('overflow', 'hidden');
            if ($(window).width() >= settings.panMinWidth) {
                isUnderSm = false;
            }
            $('html').css('overflow', htmlSaveOverflow);

            var myLatlng = new google.maps.LatLng(settings.latitude, settings.longitude);
            var mapOptions = {
                zoom: settings.zoom,
                center: myLatlng,
                scrollwheel: settings.scrollwheel,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                disableDefaultUI: true
            };

            var map = new google.maps.Map(t.get(0), mapOptions);

            mapsList[addedClass] = {
                theMap: map,
                settings: settings
            };

            var styledMap = new google.maps.StyledMapType(styles, { name: "Styled Map" });

            map.mapTypes.set('map_style', styledMap);
            map.setMapTypeId('map_style');

            if (loadings.length !== 0) {
                loadings.ClassyLoader({
                    width: 50,
                    height: 50,
                    fontSize: 10,
                    diameter: 20,
                    fontFamily: 'Lato'
                });
            }

            if (settings.panX !== 0 || settings.panY !== 0) {
                var newPanX = settings.panX;
                var newPanY = settings.panY;

                if (settings.panX.substr(settings.panX.length - 1) === '%') {
                    var percValueX = parseInt(settings.panX.substr(0, settings.panX.length - 1));
                    var mapWidth = parseInt(eleMaps.width());
                    newPanX = mapWidth / 100 * percValueX;
                }

                if (settings.panY.substr(settings.panY.length - 1) === '%') {
                    var percValueY = parseInt(settings.panY.substr(0, settings.panY.length - 1));
                    var mapHeight = parseInt(eleMaps.height());
                    newPanY = mapHeight / 100 * percValueY;
                }

                if (!isUnderSm) {
                    map.panBy(newPanX, newPanY);
                }
            }

            google.maps.event.addListenerOnce(map, 'tilesloaded', function () {
                if (settings.getLocalMarker) {
                    addSingleMarkers(t, addedClass, myLatlng, loadings, settings);
                }
                if (settings.getAjaxMarkerList && !settings.getLocalMarker) {
                    if (settings.ajaxReloadOnIdle) {
                        google.maps.event.addListener(map, 'idle', function () {
                            getMarkers(addedClass, settings.ajaxMarkerListDistance, settings.ajaxMarkerListMaxResults, t);
                        });
                    } else {
                        getMarkers(addedClass, settings.ajaxMarkerListDistance, settings.ajaxMarkerListMaxResults, t);
                    }
                }
            });
        });
    };

    var setMapBound = function setMapBound(addedClass) {
        var currMap = mapsList[addedClass].theMap;
        var markers = mapsList[addedClass].markers;
        var bounds = new google.maps.LatLngBounds();

        for (var i = 0; i < markers.length; i++) {
            bounds.extend(markers[i][0].getPosition());
        }

        currMap.fitBounds(bounds);
    };

    var setMapOnAll = function setMapOnAll(map) {
        var currMap = mapsList[map];
        var currMarkers = currMap.markers;

        for (var i = 0; i < currMarkers.length; i++) {
            currMarkers[i][0].setMap(null);
        }
    };

    var clearMap = function clearMap(map) {
        setMapOnAll(map);
        mapsList[map].markers = [];
        setMapBound(map);
    };

    win.on('load', function () {
        winWidth = win.width();
        eleMaps = $('.js-maps');
        loadings = $('.gmap-loading-item');

        createMaps();
    });

    var encodeText = function encodeText(name) {
        name = name.replace(/\\xE0/g, '\xE0');
        name = name.replace(/\\xE2/g, '\xE2');
        name = name.replace(/\\xE3/g, '\xE3');
        name = name.replace(/\\xE4/g, '\xE4');
        name = name.replace(/\\xE5/g, '\xE5');
        name = name.replace(/\\xE9/g, '\xE9');
        name = name.replace(/\\xE8/g, '\xE8');
        name = name.replace(/\\xEA/g, '\xEA');
        name = name.replace(/\\xEB/g, '\xEB');
        name = name.replace(/\\xEE/g, '\xEE');
        name = name.replace(/\\xEF/g, '\xEF');
        name = name.replace(/\\xF1/g, '\xF1');
        name = name.replace(/\\xF2/g, '\xF2');
        name = name.replace(/\\xF3/g, '\xF3');
        name = name.replace(/\\xF4/g, '\xF4');
        name = name.replace(/\\xF6/g, '\xF6');
        name = name.replace(/\\xF9/g, '\xF9');
        name = name.replace(/\\xFB/g, '\xFB');
        name = name.replace(/\\xE7/g, '\xE7');
        name = name.replace(/\\xC0/g, '\xC0');
        name = name.replace(/\\xC7/g, '\xC7');
        name = name.replace(/\\xC8/g, '\xC8');
        name = name.replace(/\\xC9/g, '\xC9');
        name = name.replace(/\\xCA/g, '\xCA');
        name = name.replace(/\\xCE/g, '\xCE');
        name = name.replace(/\\xCF/g, '\xCF');
        name = name.replace(/\\xD1/g, '\xD1');
        name = name.replace(/\\xD4/g, '\xD4');
        return name;
    };

    var decodeText = function decodeText(name) {
        name = name.replace(/\\xE0/g, 'à');
        name = name.replace(/\\xE8/g, 'è');
        name = name.replace(/\\xE9/g, 'é');
        name = name.replace(/\\xC0/g, 'À');
        name = name.replace(/\\xC8/g, 'È');
        name = name.replace(/\\xC9/g, 'É');
        return name;
    };

    var styles = [{
        "featureType": "all",
        "elementType": "all",
        "stylers": [{
            "hue": "#008eff"
        }]
    }, {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [{
            "visibility": "off"
        }]
    }, {
        "featureType": "road",
        "elementType": "all",
        "stylers": [{
            "saturation": "0"
        }, {
            "lightness": "0"
        }]
    }, {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [{
            "visibility": "off"
        }]
    }, {
        "featureType": "water",
        "elementType": "all",
        "stylers": [{
            "visibility": "simplified"
        }, {
            "saturation": "-60"
        }, {
            "lightness": "-20"
        }]
    }];
})(jQuery);
(function ($, undefined) {

	'use strict';

	var isLoggedIn = false;
	var isMobile = false;
	var win = $(window);
	var winWidth;
	var winHeight;

	var header;
	var navItems;

	var toggleMenuBtn;

	var toggleScroll = function toggleScroll() {
		var diff;

		if ($('body').hasClass('no-scroll')) {
			$('body').removeClass('no-scroll');
			diff = 0;
		} else {
			var w1 = win.width();
			$('body').addClass('no-scroll');
			var w2 = win.width();
			diff = w2 - w1;
		}

		changeScrollDiff(diff);
	};

	var changeScrollDiff = function changeScrollDiff(diff) {
		$('.js-scroll-padding').css('padding-right', diff + 'px');
		$('.js-scroll-right').css('right', diff + 'px');
	};

	var onClickMenuToggle = function onClickMenuToggle() {
		if (!!$('body').hasClass('menu-open')) {
			var transitionEnd = 'transitionend webkitTransitionEnd oTransitionEnd otransitionend';
			$('body').removeClass('menu-open');

			header.on(transitionEnd, function (e) {
				$('body').removeClass('no-scroll');
				changeScrollDiff(0);
				$(this).off(e);
			});
		} else {
			var target = 0;

			if ($('.site-header').css('scroll-y') !== 'fixed' && $('.site-header').offset().top > 0) {
				target = $('.site-header').offset().top;
			}

			if (win.scrollTop() <= $('.site-header').offset().top) {
				$('html').animate({ scrollTop: target }, 300);
				$('body').animate({ scrollTop: target }, 300, function () {
					openMenu();
				});
			} else {
				openMenu();
			}
		}
	};

	var openMenu = function openMenu() {
		$('body').addClass('menu-open');
		toggleScroll();
	};

	var closeMenu = function closeMenu() {
		if ($('body').hasClass('menu-open')) {
			$('body').removeClass('menu-open');
			toggleScroll();
		}
	};

	var updateNavSelected = function updateNavSelected(page) {
		navItems.removeClass('selected');
		var handleObj = $('.main-content ' + page);
		var handle = handleObj.attr('data-page-nav');

		navItems.each(function () {
			var t = $(this);

			if (t.data('pageNav') === handle) {
				t.addClass('selected');
			}
		});
	};

	var init = function init() {
		winWidth = win.width();
		winHeight = win.height();
		$('body').removeClass('no-scroll');

		header = $('.site-header');
		navItems = $('.nav-item-link', header);

		toggleMenuBtn = $('.site-header-menu-toggle-btn', header);

		if ($('body').hasClass('is-logged-in')) {
			isLoggedIn = true;
		}

		toggleMenuBtn.on('click', onClickMenuToggle);
		navItems.on('click', closeMenu);

		win.scroll(function () {});

		win.resize(function () {
			if (win.width() != winWidth) {
				if ($('body').hasClass('menu-open')) {
					toggleMenuBtn.trigger('click');
				}
				winHeight = win.height();
				winWidth = win.width();
			}
		});
	};

	$(init);
})(jQuery);
(function ($, undefined) {

	'use strict';

	var contactFormBtn;
	var formCom;
	var recaptcha;

	var sendContactFormEmailClass = function sendContactFormEmailClass(recaptchaResponse) {
		var t = $(this);
		var count = t.data('count');
		var form = t.closest($('.contactForm-Container'));

		var subject = $('.contactForm-subject', form).val();
		var email = $('.contactForm-email', form).val();
		var targetEmail = $('.targetEmail', form).length ? $('.targetEmail', form).val() : "";
		var content = null;
		var captchaIsOk = true;

		contactFormBtn.addClass('processing');

		try {
			content = tinyMCE.get('contactForm-content', form).getContent();
		} catch (exception) {
			content = $('.contactForm-content', form).val();
		}

		var appendField = "";
		if ($('.fieldName1') !== null) {
			var total = 9;
			if (count) {
				total = count;
			}
			for (var i = 1; i < total; i++) {
				appendField += "&fieldName" + i + "=" + encodeURIComponent($('.fieldName' + i, form).val());
				if ($('.field' + i, form).attr('type') == "checkbox") {
					if ($('.field' + i, form).checked) {
						appendField += "&field" + i + "=checked.";
					} else {
						appendField += "&field" + i + "=not checked.";
					}
				} else {
					appendField += "&field" + i + "=" + encodeURIComponent($('.field' + i, form).val());
				}
			}
			appendField += "&count=" + total;
		}
		if (targetEmail.length) {
			appendField += +"&targetEmail=" + targetEmail;
		}
		var captcha = $('.g-recaptcha', form);
		if (captcha.length) {
			var captchaResp = grecaptcha.getResponse();

			if (captchaResp.length === 0) {
				captchaIsOk = false;
			} else {
				appendField += '&captcha=' + grecaptcha.getResponse();
			}
		} else if (recaptchaResponse && typeof recaptchaResponse === 'string') {
			appendField += '&captcha=' + recaptchaResponse;
		}

		formCom.validateForm(form);

		if (form.hasClass('has-error')) {
			$('.js-form-error-message.fields', form).slideDown(200);
		} else {
			$('.js-form-error-message.fields', form).slideUp(200);
		}

		if (!captchaIsOk) {
			$('.contact-form-captcha-error', form).slideDown(200);
		} else {
			$('.contact-form-captcha-error', form).slideUp(200);
		}

		if (!form.hasClass('has-error') && captchaIsOk) {
			ajax(actionPath + "contactUs?subject=" + encodeURIComponent(subject) + "&email=" + encodeURIComponent(email) + "&content=" + encodeURIComponent(content) + appendField, sendContactFormEmailConfirmClass(form));
		} else {
			contactFormBtn.removeClass('processing');
		}
	};

	var sendContactFormEmailConfirmClass = function sendContactFormEmailConfirmClass(form) {
		form.find('input,textarea,.input-ctn').removeClass('success has-value').val('');
		form.removeClass('is-checked');

		if (window.grecaptcha) {
			grecaptcha.reset();
		}
		contactFormBtn.removeClass('processing');

		$('.js-form-success-message.form-sent', form).slideDown(300, function () {
			setTimeout(function () {
				$('.js-form-success-message.form-sent', form).slideUp(300);
			}, 10000);
		});
	};

	var init = function init(page) {
		contactFormBtn = $('.js-contact-form-send');
		formCom = Fw.component.models().form;
		recaptcha = Fw.component.models().utils.recaptcha;
		formCom.init();

		if (contactFormBtn.hasClass('render-g-recaptcha')) {
			contactFormBtn.each(function () {
				var btn = this;
				if (btn.classList.contains('render-g-recaptcha')) {
					recaptcha(btn, function (response) {
						sendContactFormEmailClass.call(btn, response);
					});
				}
			});
		} else {
			contactFormBtn.click(sendContactFormEmailClass);
		}
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);